import React, { useState } from "react";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import { useDispatch } from "react-redux";
import { getAlert } from "../../services/appAlerts";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import { resetUserPassword } from "../../app/store/auth";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [isSuccess, setIsSuccess] = useState(false);
  const schema = {
    username: Joi.string().required().label("Username"),
    validId: Joi.string().required().label("Valid ID"),
    newPassword: Joi.string().required().min(8).max(14).label("New Password"),
    confirmPassword: Joi.string()
      .required()
      .valid(Joi.ref("newPassword"))
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  const password_validate = (password) => {
    var re = {
      capital: /[A-Z]/,
      digit: /[0-9]/,
      except: /[aeiou]/,
      full: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?][A-Za-z0-9]/,
    };
    return (
      re.capital.test(password) &&
      re.digit.test(password) &&
      re.except.test(password) &&
      re.full.test(password)
    );
  };

  const doSubmit = async () => {
    const passResult = password_validate(stateData["newPassword"]);
    if (passResult) {
      const result = await dispatch(resetUserPassword(stateData));
      if (result === "error") {
        getAlert("Invalid Details", "", "error");
      } else {
        setIsSuccess(true);
      }
    } else {
      getAlert(
        "Password Strength",
        "Please enter strong password",
        "error"
      );
    }
  };

  const {
    stateData,
    stateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <div className="login-page">
      <div className="login-shell reset-password-shell">
        <div className="login-top-banner">
          <i className="fa fa-shield" aria-hidden="true"></i>
          <span>Human Resources Information Management System (HRIMS)</span>
        </div>
        <section className="login-hero" aria-label="Reset password overview">
          <p className="login-kicker">Account Security</p>
          <h1>Reset your Password</h1>
          <p className="login-copy">
            Create a new strong password for your account. Your password must
            include uppercase and lowercase letters, numbers, and at least one
            special character.
          </p>
          <div className="login-highlights" aria-label="Reset steps">
            <span>Verify identity</span>
            <span>New password</span>
            <span>Secure access</span>
          </div>
        </section>

        <section className="login-panel" aria-label="Reset Password">
          <div className="login-card reset-password-card">
            {isSuccess ? (
              <React.Fragment>
                <div className="login-card-header text-center">
                  <i
                    className="fa fa-check-circle"
                    aria-hidden="true"
                    style={{ fontSize: "48px", color: "#1a2c52" }}
                  ></i>
                  <h2 className="mt-3">Password Changed Successfully</h2>
                  <p>
                    Your password has been updated. You can now sign in
                    with your new credentials.
                  </p>
                </div>
                <Link
                  to="/Login"
                  className="btn btn-outline-default w-100"
                >
                  <i className="fa fa-sign-in mr-2" aria-hidden="true"></i>
                  Go to Login
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="login-card-header">
                  <p className="login-step-label">Reset Password</p>
                  <h2>Create a new password</h2>
                  <p>
                    <i
                      className="fa fa-hand-o-right"
                      aria-hidden="true"
                    ></i>{" "}
                    New password should contain at least 8 characters (and
                    up to 50 characters) with a mixture of both uppercase
                    and lowercase letters. A mixture of letters and numbers
                    inclusion of at least one special character, e.g., ! @ #
                    ? [no spaces allowed!].
                  </p>
                </div>

                <div className="reset-password-recovery">
                  <div className="row">
                    <div className="col-md-12">
                      {renderInput("validId", "Enter Your Valid ID")}
                    </div>
                    <div className="col-md-12">
                      {renderInput("username", "Enter Your Username")}
                    </div>
                    <div className="col-md-12">
                      {renderInput(
                        "newPassword",
                        "Enter New Password",
                        "password"
                      )}
                    </div>
                    <div className="col-md-12">
                      {renderInput(
                        "confirmPassword",
                        "Confirm Password",
                        "password"
                      )}
                    </div>
                    <div className="col-md-12">
                      <button
                        type="button"
                        className="btn btn-outline-default w-100"
                        disabled={!!validate()}
                        onClick={handleSubmit}
                      >
                        <i className="fa fa-check mr-2" aria-hidden="true"></i>
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </div>

              </React.Fragment>
            )}
          </div>
        </section>
        <div className="login-saas-banner">
          <i className="fa fa-cloud" aria-hidden="true"></i>
          <span>
            SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
